define(function (require) {
	const ViewManager = require('civicsUtils/view_manager');
	const ModalRegion = require('civicsUtils/modal_region');
	const SavedSearchesList = require('civicsViews/filter_view/saved_searches_view/v_cpv_saved_searches.js')
	const SaveSearchModal = require('../save_search_modal/v_cpv_save_search_modal.js')
	const ManageSavedSearchesModal = require('../manage_saved_searches_modal/v_cpv_manage_saved_searches_modal.js');
	const tpl = require('civicsViews/filter_view/saved_searches_template/t_lov_saved_searches.hbs')

	const saved_searches_collection =  require('civicsCollections/portal/saved_searches_collection');
	
	return Marionette.LayoutView.extend({
		template: tpl,
		tagName: 'div',
		regions: {
			modalRegion: {
				regionClass: ModalRegion,
				selector: 'body .rhythm-modals'
			},
			savedSearchesList: '.saved-searches-layout'
		},
		ui: {
			openSaveThisSearchModal: '.save-this-search-btn',
			openManageSavedSearchesModal: '.manage-saved-searches-btn',
			toggleSavedSearches: '.saved-searches-collapse'
		},
		events: {
			'click @ui.openSaveThisSearchModal': 'openSaveThisSearchModal',
			'click @ui.openManageSavedSearchesModal': 'openManageSavedSearchesModal',
			'click @ui.toggleSavedSearches': 'toggleSavedSearches'
		},
		initialize: function (options) {
			this.config = options.config;
			this.savedSearchesCollection = options.collection;
			window.addEventListener('hashchange', this.checkAndApplyDefaultSavedSearch.bind(this));
		},
		childEvents: {
			'rememberCriteria:filter': 'onTriggerRememberCriteriaFilter'
		},
		onRender: function () {
			this.savedSearchesList.show(new SavedSearchesList({
				config: this.config,
				collection: this.collection
			}));

			// Handling of collapsing items in the list 
			// Ensure the correct class is added to the .save-searches-list based on the initial state
			if (this.$('.saved-searches-layout').hasClass('open')) {
				// If open, add 'expanded' - carrot icon faces up
				this.$('.save-searches-list').addClass('expanded').removeClass('collapsed');
			} else {
				// If not open, add 'collapsed' - carrot icon faces down
				this.$('.save-searches-list').addClass('collapsed').removeClass('expanded');
			}	

			// Check if it's the use session storage config is on before applying the default filter set if there is
			if (!this.config.useSessionStorage || !App.sessionStorage.get('CIVICS', 'FILTER_MYDASH_DATA')) { 
				this.checkAndApplyDefaultSavedSearch(); 
			} else {
				this.config.defaultSearchCheckPromise?.resolve();
			}
		},
		onTriggerRememberCriteriaFilter: function (childView, savedSearchData) {
			this.triggerMethod('child:rememberCriteria:filter', savedSearchData); 
		},
		checkAndApplyDefaultSavedSearch: function () {
			let currentUrl = window.location.href;
			// HPS-142176: previously required '#tasks' already in the URL (or a non-service-provider
			// user) before applying a default search, which is never true on a cold login - skipping
			// the check entirely for service-provider users on first render.
			if (!currentUrl.includes("exflt")) {
				this.applyDefaultSavedSearch();
			} else {
				this.config.defaultSearchCheckPromise?.resolve();
			}
		},
		applyDefaultSavedSearch: function () {
			const currentUrl = window.location.origin + window.location.pathname;
			const hash = window.location.hash;

			const isTaskDashboard = this.config.filterType === 'tasks';
			const hasExistingFilterForThisTab = hash.includes(`#${this.config.filterType}/`) && hash.split(`#${this.config.filterType}/`)[1] !== '';

			const baseUrl = `${currentUrl}#${this.config.filterType}/`;

			if (hasExistingFilterForThisTab) {
				// HPS-142176: don't overwrite an existing filter for this tab with the default.
				this.config.defaultSearchCheckPromise?.resolve();
				return;
			}

			const defaultSearch = this.savedSearchesCollection.find(model =>
				model.get('isDefault') && model.get('source') === (isTaskDashboard ? 'INSPECTIONS' : 'PROJECTS')
			);

			if (defaultSearch) {
				const defaultSearchData = defaultSearch.get('searchData');
				const newUrl = `${baseUrl}${defaultSearchData}`;
				// HPS-142176: navigating away - promise left unresolved, the hashchange re-fetch takes over.
				window.location.href = newUrl;
				return;
			}

			// No default search exists for this tab - the check has run and nothing applies.
			this.config.defaultSearchCheckPromise?.resolve();
		},
		toggleSavedSearches: function() { 
			/* Toggling of showing/hiding saved searches items is manually handled here. 
			The existing functionality we have where we just add the 
			.collapsible-wrapper and .collapse-trigger classes does not work */

			// Get the current state of the section (expanded or collapsed)
			const isExpanded = this.$('.saved-searches-collapse').attr('aria-expanded') === 'true'; 
			this.$('.saved-searches-collapse').attr('aria-expanded', !isExpanded); // Flip between true and false
			
			// Toggle the 'open' class for the container (show/hide the section)
			this.$('.saved-searches-layout').toggleClass('open', !isExpanded);
			// Toggle the 'expanded' and 'collapsed' classes on the list
			this.$('.save-searches-list').toggleClass('expanded', !isExpanded).toggleClass('collapsed', isExpanded);
			// Toggle the carrot icon direction
			this.$('.expand-collapse').toggleClass('expanded', !isExpanded).toggleClass('collapsed', isExpanded);
		},
		openSaveThisSearchModal: function() {
			ViewManager.resetErrorMessages(this);
			var saveSearch = new SaveSearchModal({
				config: this.config,
				modalRegion: this.modalRegion,
				savedSearchesCollection: this.collection
			});
			this.modalRegion.show(saveSearch);
			this.modalRegion.showModal();
			return false;
		},
		openManageSavedSearchesModal: function() {
			ViewManager.resetErrorMessages(this);
			var manageSavedSearches = new ManageSavedSearchesModal({
				config: this.config,
				modalRegion: this.modalRegion,
				collection: this.collection
			});
			this.modalRegion.show(manageSavedSearches);
			this.modalRegion.showModal();
			return false;
		},
		templateHelpers: function() {
			return {
				noSavedSearch: !this.collection.length > 0,
			};
		},
	});
});
